import { useState } from "react";
import { useNightMode } from "../../../contexts/NightModeContext";
import FormattedDate from "../../../components/common/DateFormat/FormattedDate";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { toHaveDescription } from "@testing-library/jest-dom/matchers";
type CardData = {
  name?: string;
  icon?: string;
  iconImage?: string | File;
  ticket?: string;
  startDate: string;
  status?: string;
  totalUsed?: number;
  totalLimit?: number;
  optionHead?: string;
  option?: string;
  optionHead1?: string;
  option1?: string;
  optionHead2?: string;
  option2?: string;
  optionIcon2?: string;
  discount?: string;
  isActive?: boolean;
  optionIcon1?: string;
  description?: string;
  ticketGroup?: string;
  date?: string;
  hasStatusCtrl?: boolean;
};

type ListCardProps = {
  cardData: CardData;
  onEdit?: () => void;
  onDelete?: () => void;
  onToggle?: (isActive: boolean) => void;
  hasStatusCtrl?: boolean;

};
const ListCard = ({ cardData, onEdit, onDelete, onToggle,hasStatusCtrl=false }: ListCardProps) => {  const {
    name,
    icon,
    iconImage,
    ticket,
    startDate,
    status,
    totalUsed,
    totalLimit,
    optionHead,
    option,
    optionHead1,
    option1,
    optionIcon1,
    optionHead2,
    option2,
    optionIcon2,
    date,
    discount,
    isActive = true,    
    description,
    ticketGroup,
  } = cardData;
  const safeStatus = (status || "").toLowerCase();
  const statusColor = safeStatus === "active" ? "green" : safeStatus === "inactive" ? "red" : "orange";

  const [active, setActive] = useState(isActive);
  const { isNightMode } = useNightMode();
  const eventData: any = JSON.parse(localStorage.getItem("eventData") || "{}");


  const handleToggle = () => {
    const newState = !active;
    setActive(newState);
    if (onToggle) onToggle(newState);
  };
  let iconSrc: string | undefined;

    if (iconImage instanceof File) {
    iconSrc = URL.createObjectURL(iconImage); 
    } else {
    iconSrc = iconImage; 
    }


  return (
   <div className="all-promotion-list">
							<div className="main-card mt-4">
								<div className="contact-list coupon-active">
									<div className="top d-flex flex-row flex-wrap justify-content-between align-items-center p-4 border_bottom">
										<div className="icon-box d-flex flex-column align-items-start">
                                            <div>
                                                {iconImage ? (
                                                    <img
                                                    src={iconSrc}
                                                    alt={name}
                                                    className="icon-big icon icon-purple"
                                                    />
                                                ) : (
                                                    <span className={`icon-big ${icon==='fa-solid fa-ticket'?'rotate-icon':''} icon icon-purple`}>
                                                    <i className={icon}></i>
                                                    </span>
                                                )}
                                            </div>
											<h5 className="font-18 mb-1 mt-1 f-weight-medium"style={{whiteSpace: "normal",wordBreak: "break-word",}}>{name}</h5> {ticket &&  (
                                             <p className="text-gray-50 m-0 small">{ticket}</p>
)}
                                            <div>

                                            <p className="text-gray-50 m-0"><span className="visitor-date-time">{description}</span></p>
                                            </div>
                                            <div>
											<p className="text-gray-50 m-0"><span className="visitor-date-time">Added : <FormattedDate dateString={startDate} /></span></p>
                                            {ticketGroup && (
                                                <p className="text-gray-50 m-0"><span className="visitor-date-time">Ticket Group : {ticketGroup}</span></p>
                                            )}
                                            </div>
										</div>
										<div className="d-flex align-items-center ms-auto">
											{/* <label className="btn-switch tfs-8 mb-0 me-4 mt-1">
												<input type="checkbox" value="" checked></input>
												<span className="checkbox-slider"></span>
											</label> */}
											<div className="dropdown dropdown-default dropdown-text dropdown-icon-item">
												<button className="option-btn-1" type="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
													<i className="fa-solid fa-ellipsis-vertical"></i>
												</button>
												<div className="dropdown-menu dropdown-menu-right">
                                                {onEdit && (
                                                    <button className="dropdown-item" type="button" onClick={onEdit}>
                                                    <i className="fa-solid fa-pen me-3"></i>Edit
                                                    </button>
                                                )}
                                                {onDelete && (
                                                    <button className="dropdown-item" type="button" onClick={onDelete}>
                                                    <i className="fa-solid fa-trash-can me-3"></i>Delete
                                                    </button>
                                                )}
                                                </div>
											</div>
										</div>
									</div>
									<div className="bottom d-flex flex-wrap justify-content-between align-items-center p-4">
                                    {status && (
                                    <div className="icon-box d-flex flex-column align-items-start">
                                        <div className="d-flex align-items-center">
                                        <span className="icon" style={{ background: "transparent" }}>
                                            {hasStatusCtrl ? (
                                            <label className="btn-switch m-0">
                                                <input
                                                type="checkbox"
                                                checked={isActive}
                                                onChange={(e) => onToggle && onToggle(e.target.checked)}
                                                />
                                                <span className="checkbox-slider"></span>
                                            </label>
                                            ) : (
                                            <i className="fa-regular fa-circle-dot"></i>
                                            )}
                                        </span>
                                        <p className="m-0 ms-2">Status</p>
                                        </div>
                                        <h6 className="coupon-status d-flex align-items-center mt-1">
                                        <i
                                            className="fa-solid fa-circle me-2"
                                            style={{ color: isActive ? "green" : "red" }}
                                        ></i>
                                        {isActive ? "Active" : "Inactive"}
                                        </h6>
                                    </div>
                                    )}
                                         {totalLimit !== undefined && (
										<div className="icon-box d-flex flex-column align-items-start">
                                            <div>
											<span className="icon">
												<i className="fa-solid fa-chart-column"></i>
											</span>
											<p>Total used</p>
                                            </div>
                                            <div>
											<h6 className="coupon-status">{totalUsed}/{totalLimit === 0 || totalLimit === null ? 'Unlimited' : totalLimit}</h6>
                                            </div>
										</div>
                                        )}
                                        { optionHead && (
                                        <div className="icon-box d-flex flex-column align-items-start">
                                            <div>
											<span className="icon">
												<i className="fa-solid fa-tag"></i>
											</span>
											<p>{optionHead}</p>
                                            </div>
                                            <div>
											<h6 className="coupon-status">{option}</h6>
                                            </div>
										</div>
                                        )}
										{optionHead1 && (
                                        <div className="icon-box d-flex flex-column align-items-start">
                                            <div>
                                            <span className="icon">
                                                <i className={optionIcon1}></i>
                                            </span>
                                            <p>{optionHead1}</p>
                                            </div>
                                            <div>
                                            <h6 className="coupon-status">{option1}</h6>
                                            </div>
                                        </div>
                                        )}
                                        {optionHead2 && (
                                        <div className="icon-box d-flex flex-column align-items-start">
                                            <div>
                                            <span className="icon">
                                                <i className={optionIcon2}></i>
                                            </span>
                                            <p>{optionHead2}</p>
                                            </div>
                                            <div>
                                            <h6 className="coupon-status">{option2}</h6>
                                            </div>
                                        </div>
                                        )}
                                         {date && (
                                        <div className="icon-box d-flex flex-column align-items-start">
                                            <div>
                                            <span className="icon">
                                                <i className="fa-solid fa-calendar"></i>
                                            </span>
                                            <p>Date</p>
                                            </div>
                                            <div>
                                            <h6 className="coupon-status">{date}</h6>
                                            </div>
                                        </div>
                                        )}
									</div>
								</div>
							</div>
						</div>
  );
}
export default ListCard;